import firebase from './Firebase'


export const CHATS_REF = firebase.database().ref().child('chats')
export const STGREF = firebase.storage().ref()